/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Ux_Title2Inputs */

const en_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popup & settings UI`)
};

const ar_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة النافذة المنبثقة والإعدادات`)
};

const bn_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পপআপ ও সেটিংস UI`)
};

const de_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popup- und Einstellungs-Benutzeroberfläche`)
};

const es_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfaz de usuario emergente y de configuración`)
};

const fr_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface utilisateur contextuelle et de paramètres`)
};

const pt_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU de pop-up e configurações`)
};

const zh_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`弹出窗口和设置 UI`)
};

const tr_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açılır pencere ve ayarlar kullanıcı arayüzü`)
};

const ru_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всплывающий интерфейс и настройки`)
};

const pl_svc_browser_extensions_ux_title2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfejs wyskakującego okienka i ustawień`)
};

/**
* | output |
* | --- |
* | "Popup & settings UI" |
*
* @param {Svc_Browser_Extensions_Ux_Title2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_ux_title2 = /** @type {((inputs?: Svc_Browser_Extensions_Ux_Title2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Ux_Title2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_ux_title2(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_ux_title2(inputs)
	if (locale === "de") return de_svc_browser_extensions_ux_title2(inputs)
	if (locale === "es") return es_svc_browser_extensions_ux_title2(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_ux_title2(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_ux_title2(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_ux_title2(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_ux_title2(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_ux_title2(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_ux_title2(inputs)
	return en_svc_browser_extensions_ux_title2(inputs)
});
export { svc_browser_extensions_ux_title2 as "svc_browser-extensions_UX_title" }